<script>
import { confirmComputed, confirmMethods } from '@state/helpers'
export default {
  data: function() {
    return {
      open: false,
      timer: null,
      timeLeft: 10,
    }
  },
  computed: {
    ...confirmComputed,
    titleComputed() {
      return this.title
    },
    messagesComputed() {
      return this.messages
    },
    userComputed() {
      return this.currentUser
    },
  },
  watch: {
    errorConfirmed() {
      this.showConfirmDialog(this.errorConfirmed)
    },
    sessionIsEnded() {
      this.handleBackToLogin()
    },
  },
  methods: {
    ...confirmMethods,
    showConfirmDialog(confirm) {
      this.open = confirm
    },
    toggleDialog(value) {
      if (!value) {
        // force back to login
        if (this.sessionIsEnded) {
          this.forceBackLogin()
        }
        this.reset()
      }
    },
    handleBackToLogin() {
      // back to login page after 10 second
      if (this.timeLeft > 0) {
        this.timer = setTimeout(
          function() {
            this.timeLeft -= 1
            this.handleBackToLogin()
          }.bind(this),
          1000
        )
      } else {
        clearTimeout(this.timer)
        this.forceBackLogin()
      }
    },
    forceBackLogin() {
      const currentUser = this.$store.state.auth.currentUser
      const agentCode = currentUser?.agent?.agent_code
      this.timeLeft = 0
      this.reset()
      this.$router.push({
        name: 'login',
        query: {
          ...(agentCode && {
            agent_code: agentCode,
          }),
        },
      })
    },
  },
}
</script>

<template>
  <CModal
    :title="titleComputed"
    color="danger"
    :show.sync="open"
    centered
    @update:show="toggleDialog"
  >
    <p v-if="sessionIsEnded" class="mb-2"
      >自動的にログイン画面に切り替わります {{ timeLeft }} 秒</p
    >
    <pre>{{ messagesComputed }}</pre>
    <template v-slot:footer="slotProps">
      <CButton color="dark" type="button" @click="toggleDialog(false)">{{
        $t('common.cancel')
      }}</CButton>
      <CButton
        color="danger"
        type="button"
        :class="slotProps.class"
        @click="toggleDialog(false)"
        >{{ $t('common.ok') }}</CButton
      >
    </template>
  </CModal>
</template>
